import PropTypes from 'prop-types';

export const BannerPropTypes = {
  type: PropTypes.oneOf(['trialActive', 'cleaningInProgress', 'limitedProtection', 'fullProtectionActive', 'expiredProtection']).isRequired,
  trialDaysLeft: PropTypes.number,
};

export const TitlePropTypes = {
  loading: PropTypes.bool,
};

export const TitleDefaultProps = {
  loading: false,
};

export const ToggleRowPropTypes = {
  onToggle: PropTypes.func,
  enabled: PropTypes.bool,
  lastScan: PropTypes.string,
};

export const ToggleRowDefaultProps = {
  onToggle: undefined,
  enabled: undefined,
  lastScan: undefined,
};

export const MetricsPropTypes = {
  maliciousCodesRemoved: PropTypes.number,
  compromisedFiles: PropTypes.number,
  onToggle: PropTypes.func,
  enabled: PropTypes.bool,
  lastScan: PropTypes.string,
  withToggle: PropTypes.bool,
};

export const MetricsDefaultProps = {
  maliciousCodesRemoved: 0,
  compromisedFiles: 0,
  onToggle: undefined,
  enabled: undefined,
  lastScan: undefined,
  withToggle: undefined,
};

export const TeamAlertPropTypes = {
  variant: PropTypes.oneOf(['intervention', 'resolved']).isRequired,
  threatsNumber: PropTypes.number,
  onOpenTicket: PropTypes.func,
};

export const SummaryPropTypes = {
  content: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  testId: PropTypes.string,
  children: PropTypes.func.isRequired,
};

export const SummaryDefaultProps = {
  loading: false,
  testId: 'summary',
};
